// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchHelpScoutTokenParams = {
    appId: any,
    secret: any,
};

type SubmitFeedbackParams = {
    authToken: string,
    feedbackObject: any,
};

export default {
    fetchHelpScoutToken: ({ appId, secret }: FetchHelpScoutTokenParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'oauth2/token',
                path: '<HELP-SCOUT>',
            });
            request.send({
                client_id: appId,
                client_secret: secret,
                grant_type: 'client_credentials',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    submitFeedback: ({ authToken, feedbackObject }: SubmitFeedbackParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'conversations',
                authToken,
                path: '<HELP-SCOUT>',
            });
            request.send(feedbackObject);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
